module.exports = __webpack_public_path__ + "static/protect-our-way-of-living-c8b2b4cb7a2d956805fa80265e193a32.svg";